/*
* 前端路由表文件
* */
import Vue from 'vue'
import Router from 'vue-router'

// 登录
const login = resolve => {
  require.ensure(['@/components/common/newLogin/login'], () => {
    resolve(require('@/components/common/newLogin/login'), 'login')
  })
}

// 创建企业
const createTenant = resolve => {
  require.ensure(['@/components/common/newLogin/createTenant'], () => {
    resolve(require('@/components/common/newLogin/createTenant'), 'createTenant')
  })
}

const forgetPassword = resolve => {
  require.ensure(['@/components/common/newLogin/forgetPassword.vue'], () => {
    resolve(require('@/components/common/newLogin/forgetPassword.vue'), 'forgetPassword');
  });
};

const registerAccount = resolve => {
  require.ensure(['@/components/common/newLogin/registerAccount.vue'], () => {
    resolve(require('@/components/common/newLogin/registerAccount.vue'), 'registerAccount');
  });
};

const register = resolve => {
  require.ensure(['@/components/common/register'], () => {
    resolve(require('@/components/common/register'), 'register');
  });
};

const tempLogin = resolve => {
  require.ensure(['@/components/common/newLogin/tempLogin.vue'], () => {
    resolve(require('@/components/common/newLogin/tempLogin.vue'), 'tempLogin');
  });
};

const bindUser = resolve => {
  require.ensure(['@/components/common/newLogin/bindUserV2.vue'], () => {
    resolve(require('@/components/common/newLogin/bindUserV2.vue'), 'bindUser');
  });
};

const industryChoice = resolve => {
  require.ensure(['@/components/common/industryChoice.vue'], () => {
    resolve(require('@/components/common/industryChoice.vue'), 'industryChoice');
  });
};

const industrialCloudJump = resolve => {
  require.ensure(['@/components/common/industrialCloudJump.vue'], () => {
    resolve(require('@/components/common/industrialCloudJump.vue'), 'industrialCloudJump');
  });
};
const returnPage = resolve => {
  require.ensure(['@/components/common/returnPage.vue'], () => {
    resolve(require('@/components/common/returnPage.vue'), 'returnPage');
  });
};
const adPage = resolve => {
  require.ensure(['@/components/common/adPage.vue'], () => {
    resolve(require('@/components/common/adPage.vue'), 'adPage');
  });
};
//移动云对接
const mobileCloud = resolve => {
  require.ensure(['@/components/common/mobileCloud.vue'], () => {
    resolve(require('@/components/common/mobileCloud.vue'), 'mobileCloud');
  });
};

Vue.use(Router);

export default new Router({
  mode:"hash",//hash history hash:在地址栏有 # 隔开 history：不会有#隔开
  routes: [
    {
      path:'*',
      name: 'login',
      redirect: '/',
      component:login
    },
    {
      path:'/',
      name:'login',
      component:login
    },
    {
      path:'/createTenant',
      name:'createTenant',
      component:createTenant
    },
    {
      path:'/register',
      name:'register',
      component:register
    },
    {
      path:'/templogin',
      name:'templogin',
      component:tempLogin
    },
    {
      path:'/bindUser',
      name:'bindUser',
      component:bindUser
    },
    {
      path:'/industryChoice',
      name:'industryChoice',
      component:industryChoice
    },
    {
      path:'/industrialCloudJump',
      name:'industrialCloudJump',
      component:industrialCloudJump
    },
    {
      path:'/returnPage',
      name:'returnPage',
      component:returnPage
    },
    {
      path:'/adPage',
      name:'adPage',
      component:adPage
    },
    {
      path:'/forgetPassword',
      name:'forgetPassword',
      component:forgetPassword
    },
    {
      path:'/registerAccount',
      name:'registerAccount',
      component:registerAccount
    },
    {
      path:'/mobileCloud',
      name:'mobileCloud',
      component:mobileCloud
    },
  ]
});





// WEBPACK FOOTER //
// ./src/router/index.js